var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-info btn_nanosoft"},[_c('download-excel',{attrs:{"name":"تقرير الترقيات","stringifyLongNum":true,"fetch":_vm.fetchData,"fields":_vm.json_fields,"header":[
      _vm.name,
      _vm.desc,
      ("كشف بأسماء الموظفين المرشحين للترقية للدرجة " + _vm.gradeString + " و " + _vm.aboveGradeString + " الذين انهو الحد الأدنى في درجاتهم الوظيفية عن شهر " + (_vm.convert_Month(
        _vm.month
      ))) ]}},[_vm._v(" طباعة Excel ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }